// 更新token逻辑

import { refreshToken } from "@/service/GenerateAI/index";

import { getToken, setCookieVal } from "./localToken";


let updateToken = false; // 是否刷新token中
// 刷新token
export function refreshLoginInfo() {
  if (updateToken) {
    return;
  }
  updateToken = true;
  let expiration = Number(getToken('iyuanwu_expiration'));
  let now = Date.parse(new Date());
  if (now >= expiration - 1800000) { // 30分=1800000毫秒;提前半小时判断token是否过期过期则更新token后再执行请求
    refreshToken(getToken('iyuanwu_refreshToken')).then(res => {
      console.log("更新前过期时间------", expiration);
      let newTime = res.data * 1000 + new Date().getTime();
      console.log("更新token后获得的时间------", res.data);
      console.log("计算后的时间------", newTime);
      setCookieVal('iyuanwu_expiration', newTime);
      let iframe = document.getElementById('iframeLogin');
      if (iframe) {
        iframe.contentWindow.postMessage({ iyuanwu_expiration: newTime }, '*');
      }
      updateToken = false;
    }).catch(() => {
      updateToken = false;
    });
  } else {
    updateToken = false;
  }
}